(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.BoStickyA11y = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  function setVisibility(sticky, visible) {
    if (!sticky) return;
    sticky.classList.toggle('is-visible', Boolean(visible));
    sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    sticky.inert = !visible;
    var focusable = sticky.querySelectorAll('a, button, input, select, textarea, [tabindex]');
    Array.prototype.forEach.call(focusable, function (node) {
      if (visible) node.removeAttribute('tabindex');
      else node.setAttribute('tabindex', '-1');
    });
  }

  function mobileState(rect, viewportHeight, passed) {
    if (rect.top > viewportHeight) return { passed: false, visible: false };
    if (rect.bottom < 0) return { passed: true, visible: true };
    return { passed: Boolean(passed), visible: false };
  }

  return { setVisibility: setVisibility, mobileState: mobileState };
});
